import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUniversityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/findProfessionList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "post",
          url: "/report/initialPlan/findSchemeList",
          data: params
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      } catch (e) {
        console.log(e);
      }
    });
  },
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/findBasicConfigData`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  removeScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/remove`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/findSchemeUniversity`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  sendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/sendScheme`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/configPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUniversityId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/university/findIdByUniversityName`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSpecialityInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/profession/findIdBySpecialityName`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getLeaveMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/initialPlan/findLeaveMessage`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getTreeData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report/initialPlan/getTreeData`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSpecialityPackageData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/crmSpecialityPackage/page`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/crmSpecialityPackage/` + params.id, {})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  deletById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.delete(`/crmSpecialityPackage/` + params.id, {})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  saveSpecialityPackageData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/crmSpecialityPackage/saveOrUpdate`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
};
